import CurrencyToggle from "component/currencyToggle";
import React from "react";
import Metrics from "../Metrics";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import FilterButton from "component/FilterDropdown";
import { sortByTimeFrame as byTimeFrameList } from "constants/global";

const checkInvoiceCount = (invoiceCount) => {
    return invoiceCount > 1 ? "invoices" : "invoice";
};

const InvoiceAnalytics = ({
    isBusinessApproved,
    business,
    loadingStats,
    invoiceSummary,
    currency,
    setSortByTimeFrame,
    sortByTimeFrame,
}) => {
    return (
        <div className="">
            <div className="flex items-center gap-x-5">
                <CurrencyToggle
                    className=""
                    dropDownClassName="shadow-dropdown2 !left-0 !top-[109%]"
                    isDisabled={!isBusinessApproved}
                    fetchWallet
                    businessId={business?._id}
                />

                <div className="h-4" style={{ borderLeft: "1px solid #E7E9FB" }} />

                <FilterButton
                    type="Filter"
                    filterList={byTimeFrameList}
                    onSelect={(tab) => setSortByTimeFrame(tab)}
                    selected={
                        byTimeFrameList.find((item) => item.value === sortByTimeFrame)?.text ||
                        sortByTimeFrame
                    }
                />
            </div>

            <div className="sm:mx-10 md:mx-0 mb-2 grid grid-cols-[repeat(3,minmax(280px,1fr))] gap-6 overflow-x-auto [scrollbar-width:none]">
                <Metrics
                    title={"Total"}
                    value={
                        loadingStats
                            ? "--"
                            : `${
                                  currencyPairCheck(currency) +
                                  formatMoney(
                                      invoiceSummary?.["outbound"]?.totalAmount +
                                          invoiceSummary?.["inbound"]?.totalAmount
                                  )
                              }`
                    }
                    meta={
                        loadingStats
                            ? "--"
                            : `${
                                  invoiceSummary?.["outbound"]?.count +
                                  invoiceSummary?.["inbound"]?.count
                              } ${checkInvoiceCount(
                                  invoiceSummary?.["outbound"]?.count +
                                      invoiceSummary?.["inbound"]?.count
                              )} `
                    }
                />
                <Metrics
                    title={"Outgoing"}
                    value={
                        loadingStats
                            ? "--"
                            : `${
                                  currencyPairCheck(currency) +
                                  formatMoney(invoiceSummary?.["outbound"]?.totalAmount)
                              }`
                    }
                    meta={
                        loadingStats
                            ? "--"
                            : `${invoiceSummary?.["outbound"]?.count} ${checkInvoiceCount(
                                  invoiceSummary?.["outbound"]?.count
                              )}`
                    }
                />
                <Metrics
                    title={"Incoming"}
                    value={
                        loadingStats
                            ? "--"
                            : `${
                                  currencyPairCheck(currency) +
                                  formatMoney(invoiceSummary?.["inbound"]?.totalAmount)
                              }`
                    }
                    meta={
                        loadingStats
                            ? "--"
                            : `${invoiceSummary?.["inbound"]?.count} ${checkInvoiceCount(
                                  invoiceSummary?.["inbound"]?.count
                              )}`
                    }
                />
            </div>
        </div>
    );
};

export default InvoiceAnalytics;
